<script lang="ts" setup>
import { computed } from "vue";
import { visibleMenuItemsFor } from "@/components/layouts/utils";
import { useContextStore } from "@/stores/context.store";
import { useLayoutStore } from "@/store/app";
import { SIDEBAR_SIZE } from "@/app/const";
import { useRoute, useRouter } from "vue-router";
import { MenuItemType } from "@/components/layouts/types";

const state = useLayoutStore();
const contextStore = useContextStore();
const route = useRoute();
const router = useRouter();

const path = computed(() => route.path);

const visibleMenuItems = computed(() => {
  return visibleMenuItemsFor(
    contextStore.enabledModuleKeys,
    contextStore.isAdminUser,
    contextStore.isCaravelAdmin
  );
});

const isCompactSideBar = computed(() => {
  return state.sideBarSize === SIDEBAR_SIZE.COMPACT;
});

const isActive = (menuItem: MenuItemType) => {
  if (!menuItem.link) return false;

  if (menuItem.link === "/") {
    return path.value === "/";
  }

  return path.value === menuItem.link || path.value.startsWith(`${menuItem.link}/`);
};

const onClick = (targetPath: string) => {
  router.push(targetPath);
};
</script>

<template>
  <v-container fluid class="caravel-menu-container">
    <v-list
      class="navbar-nav caravel-menu-list"
      id="navbar-nav"
      open-strategy="single"
    >
      <v-list-item
        v-for="menuItem in visibleMenuItems"
        :key="menuItem.id"
        :data-key="menuItem.id"
        append-icon=""
        class="caravel-menu-item"
        :class="{ 'caravel-menu-item--active': isActive(menuItem) }"
        :value="menuItem.link"
        :active="isActive(menuItem)"
        height="52"
        min-height="52"
        @click.prevent="menuItem.link && onClick(menuItem.link)"
      >
        <template #title>
          <div
            class="caravel-menu-link"
            :class="isCompactSideBar ? 'pa-2' : 'd-flex align-center'"
          >
            <i :class="menuItem.icon" class="ph-lg" />
            <span>{{ menuItem.label }}</span>
          </div>
        </template>
      </v-list-item>
    </v-list>
  </v-container>
</template>
